module.exports = __webpack_public_path__ + "static/media/Vector.996bc272.png";